import { toggle } from "./toggle";

export default toggle("demo-dependencies-enabled");
